<div class="instructions-container">
    <img class="full-width-img" src="images/extra_elements/instructions/zikaron_szemelyes_tortenelem.jpg" alt=""/>
    
    <p>
        Évek óta lapozgatom a közel egy évszádos családi fotóalbumunkat.
        Felmenőim személyes történetei nagymamám kézírásával vizitkártyák hátoldalain elevenednek meg:
        munkaszolgálat, deportálás, rejtőzködés, a holokauszt borzalmai.
        A vizitkártyákból kártyákat készítettem, amelyeken az élettörténetek eredeti
        formájukban olvashatók.
    </p>

    <p>
        A weboldal látogatóinak a kártyák előlapjához tartozó
        hátlapot kell megtalálniuk, egy-egy fotóhoz a hozzátartozó történet párosítandó.
        Ha a kurzort az alsó sorban található kártyalapok fölé visszük, a kártyák megnagyobbodnak,
        az írás olvashatóvá válik. Amennyiben helyes a találat, a kártyák két csoportba rendeződnek:
        akik túlélték a háborút és akik sosem tértek vissza.
    </p>

    <div class="posters-container">
        {#each Array(3) as _, i}
            <img class="poster-img" src={`images/extra_elements/instructions/zikaron_plakat${i+1}.jpg`} alt=""/>
        {/each}
    </div>

    <h1>Hogyan játszható a Zikaron társasjáték nem online?</h1>

    <h2><u>A Zikaron társasjáték tartozékai</u></h2>

    <ul>
        <li>Kártyapakli (42 db életkártya)</li>
        <li>Játéktábla (8 db)</li>
        <li>Játékosok száma: min. 4 fő</li>
        <li>Ajánlott életkor: 18 - 99</li>
    </ul>

    <h2><u>A Zikaron társasjáték előkészítése</u></h2>

    <ul>
        <li>Válasszunk játékmestert: a játékmester a legidősebb játékos.</li>
        <li>A játékmester az összes kártyát írással lefelé, arcképpel felfelé szabályos sorokba
            rendezi el. Minden sorban hét kártya szerepel, hat sor jön létre.
        </li>
        <li>A játékosok az asztal körül helyezkednek el és maguk elé vesznek egy-egy játéktáblát.</li>
    </ul>

    <img class="full-width-img" src="images/extra_elements/instructions/jatektabla.jpg" alt=""/>
    <p class="image-title"><i>A Zikaron játéktábla</i></p>

    <h2><u>A Zikaron társasjáték “szabályai”</u></h2>

    <ul>
        <li>A játékosok körben, az óramutató járásával megegyező irányban haladnak.</li>
        <li>Minden körben az éppen soron következő játékos két tetszőleges kártyát vesz fel
            az asztalról, amelyeknek az írásos tartalmát csak ő ismerheti meg. A húzás során a
            kártya arcképét kötelező körbemutatni.
        </li>
        <li>Amennyiben a húzott két kártyán olvasható életutak megfeleltethetők egymásnak, ők - kizárólag
            párban - vagy a “TÚLÉLŐ” vagy a “DEPORTÁLT” pakliba helyezendők.
        </li>
        <li>Amennyiben nem feleltethetőek meg egymásnak, visszakerülnek eredeti helyükre
            az asztalra, továbbra is írással lefelé, arcképpel felfelé.
        </li>
        <li>Minden játékos maximum két egymás utáni körben tehet vissza kártyát az
            asztalra. Amennyiben már kétszer visszahelyezte, köteles az épp húzott kártyákat
            a szabályok szerint a saját paklijába, a játéktáblájára elhelyezni.
        </li>
    </ul>

    <h4>További akciók éppen soron következő játékos esetén:</h4>

    <p>A játék során nincs biztosíték arra, hogy a játékosok a húzott kártyáikkal
        betartják a játék “szabályait”. Megtörténhet, hogy a kártyapárokon szerepelő
        életutak nem felelnek meg egymásnak, illetve a szöveg tartalmától függetlenül a
        játékos a “TÚLÉLŐ” vagy a “DEPORTÁLT” pakliba helyezi őket. Így minden soron következő
        játékos egy további akció közül választhat:
    </p>

    <h4>A “gyanú”</h4>

    <ul>
        <li>A “gyanú” megfogalmazása: az épp soron következő játékos kártyaműveletének elvégzése
            előtt vagy után élhet a gyanú jogával, megszólítja játékostársait és szóban megjelöli
            azt a játékost, aki szerinte eltér a szabályoktól: “X játékos gyanús.”
            A következő bekezdésben ismertetett “vád” akciót csak gyanúsítást követően lehet alkalmazni.
        </li>
    </ul>

    <h4>A “vád”</h4>

    <ul>
        <li>
            A “vád” megfogalmazása: az éppen soron következő játékos nem végzi el a
            kártyaműveletét, hanem vádat fogalmaz meg egy általa vagy más által már
            korábban gyanúsnak ítélt játékossal szemben.
        </li>
        <li>
            Akivel szemben nem merült fel korábban gyanú, nem vádolható.
        </li>
        <li>
            A vád megfogalmazásának tartalmaznia kell, hogy a vádolt játékos
            mely paklija tartalmazza a “hamis” életutakat.
        </li>
        <li>
            Amennyiben a vád bizonyítást nyer, a megvádolt játékos kiesik,
            a nem megfelelő paklija kikerül, az addig gyűjtött kártyái (paklijai)
            pedig a vádlóhoz kerülnek. A vádló átnézheti a fennmaradó paklit, tetszőlegesen
            kivehet belőle kártyákat, amelyek végleg kikerülnek a játékból.
        </li>
        <li>
            Amennyiben a vád nem kerül bizonyításra, a vádló köteles
            átadni a megvádolt játékosnak saját azonos pakliját, amelyet
            vádjában megnevezett. A megvádolt játékos a szerzett pakli kártyáit
            nem mutatja meg játékostársainak, a kártyákat a saját paklijai között tetszőlegesen osztja el.
        </li>
    </ul>

    <img class="full-width-img" src="images/extra_elements/instructions/jatekszabaly1.jpg" alt=""/>

    <h4>Akciók körön kívül:</h4>

    <h4>Az “elutasító magatartás”</h4>

    <ul>
        <li>
            Amennyiben valaki észleli, hogy egy játékos egymás után több mint
            kétszer helyezi vissza húzott kártyáit az asztalra, felhívhatja a
            többiek figyelmét az elutasító magatartásra. “X játékos elutasító magatartást tanúsít.”
        </li>
        <li>
            Amennyiben az elutasító magatartást az állítólag szabálytalanul cselekvő
            játékos nem ismeri el, a játékmester dönt a szabálytalanság tényéről.
        </li>
        <li>
            Amennyiben a játékmester megállapítja a szabálytalanságot (jogában áll nem elismerni),
            a szabálytalan játékos köteles egyik szabadon választott saját
            paklijának legfelső két kártyáját a másik paklijának tetejére helyezni.
        </li>
        <li>
            Amennyiben a szabálytalankodó játékos elutasító magatartásának
            megállapításakor nem rendelkezik kártyákkal, köteles párt húzni és a kártyákkal
            a megszokott módon eljárni, így automatikusan “gyanúba” keveredik, bármikor vádolható.

        </li>
    </ul>

    <h4>Ítélet</h4>

    <ul>
        <li>
            Az ítélet bármikor bemondható az adott játékos és a játékos paklijának
            megnevezésével. Az ítélet abban az esetben hajtható végre, ha az összes
            játékos egyetért: az egyetértés hangos bemondással fejezhető ki. Egyetértés
            esetén a vádlott a vádlott paklijának összes kártyáját nyilvánosan, sorban felolvassa.
            Az elítélt játékos mindenképpen kiesik.
        </li>
    </ul>

    <h4>A játék vége</h4>

    <ul>
        <li>
            A kártyák az asztalról elfogynak. Mindenki összeszámolja a paklikban
            szerepelő kártyákat és hangosan tudatja a többiekkel. A kártyák nem kerülnek
            felfedésre. A játék véget ér.
        </li>
        <li>
            A kiesések során két játékos marad játékban. Ebben az esetben a játékosok
            helyet cserélnek, ellenőrzik ellenfelük pakliját. Amennyiben a paklikban a
            kártyák nem szabályszerűen rendeződnek el, a szabályszegő játékos(ok) húznak az
            asztalról 1 kártyát, amelyen szerepelő életúttal azonosulnak, deportáltak vagy
            túlélők lesznek. A szabályszerű pakli esetén további teendőnk nincs. A játék véget ér.
        </li>
    </ul>

    <img class="full-width-img" src="images/extra_elements/instructions/jatekszabaly2.jpg" alt=""/>

    <h4>A játék készítői:</h4>

    <p>
        Pátkai Rozina - koncepció, leírás, digitalizálás, fotók <br>
        Süle Tamás - grafika <br>
        Kiss Benedek - programozás <br>
        <br>

        Hangeffektek - Zapsplat.com

        <br><br>

        A Zikaron a ZSK2028 Mentorprogram támogatásával készült.
    </p>

</div>

<style>
    .full-width-img {
        width: 100%;
    }
    
    .poster-img {
        width: 16vw;
        height: intrinsic;
    }

    .posters-container {
        display: flex;
        justify-content: space-around;

    }
    h1 {
        text-align: center;
        margin: 70px 0px;
        line-height: 46px;
    }

    .image-title {
        text-align: center;
        font-size: 20px;
    }
</style>